import memoizeOne from 'memoize-one';

export const getFindReplaceOptions = memoizeOne(() => {
	return { allowMatchCase: true };
});
